import { render, staticRenderFns } from "./MaterialTypeSelector.vue?vue&type=template&id=15f40a3d&"
import script from "./MaterialTypeSelector.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTypeSelector.vue?vue&type=style&index=0&id=15f40a3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports